// "QB Process" bucket for a workflow row. The value is a clients-overlaid
// text field ('' | 'Manual' | 'Online'), matched case-insensitively like the
// QbProcessToggle does; blanks and legacy values (NA, No Bookkeeping, …)
// bucket as 'none'. Shared by the Workflow V2 QB Process chip and the
// Dashboard's Bookkeeping Pipeline so their counts agree.

import { displayValue, type WorkflowRow } from './api';
import type { QbProcessMode } from './components/StatusFilterChips';

export const QB_PROCESS_COLUMN = 'QB Process';

export const QB_PROCESS_MODES: QbProcessMode[] = ['manual', 'online', 'none'];

export function rowQbProcessMode(data: WorkflowRow['data']): QbProcessMode {
  const value = displayValue(data[QB_PROCESS_COLUMN]).toLowerCase();
  if (value.includes('manual')) return 'manual';
  if (value.includes('online')) return 'online';
  return 'none';
}

/** Zeroed per-bucket counter */
export function emptyQbProcessCounts(): Record<QbProcessMode, number> {
  return { manual: 0, online: 0, none: 0 };
}
